module.exports = __webpack_public_path__ + "img/46.2.TN.75dd9edd.png";